import React, { useEffect, useState } from "react";

// components
import Loader from "../../Container/Loader";

// -- redux
import { connect } from "react-redux";
import {
  AddMobileConfiguration,
  GetMobileConfiguration,
} from "../../Redux/Actions/mobileConfigurationActions";

function MobileConfiguration(props) {
  const [id, setID] = useState("");
  const [URL, setURL] = useState("");
  const [hide, setHide] = useState("");
  const [URLError, setURLError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    let expression =
      /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
    let regex = new RegExp(expression);
    if (URL.match(regex)) {
      setURLError("");
      const data = {
        id: id,
        search_url: URL,
      };
      props.AddMobileConfiguration(data);
    } else {
      setURLError("Invalid URL");
    }
  };

  useEffect(() => {
    props.GetMobileConfiguration();
    setHide(true);
  }, []);

  useEffect(() => {
    if (props.get_data.status === 200) {
      props.get_data.data.map((data) => {
        setID(data.id);
        setURL(data.information);
      });
      setTimeout(function () {
        setHide(false);
      }, 2000);
    }
  }, [props.get_data]);

  return (
    <>
      {props.loading && <Loader />}
      <div className="ml-4 mr-4 mt-5">
        <label className="text-grey-6 f-16 d-block mb-1">Search URL</label>
        <input
          type="text"
          placeholder="Enter search URL"
          className="w-100"
          onChange={(e) => setURL(e.target.value)}
          value={URL}
        />
        {URLError && <p className="f-12 text-danger">{URLError}</p>}
        <div className="d-flex justify-content-between mt-5">
          {/* <button
            className="form-button"
            disabled={!URL}
            onClick={() =>
              props.history.push({
                pathname: "/dashboard/questions",
                back: "yes",
              })
            }
          >
            Cancel
          </button> */}
          <button
            className="form-button"
            disabled={!URL}
            onClick={(e) => handleSubmit(e)}
          >
            Save
          </button>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = ({ mobileConfigurationReducer }) => {
  const { loading, data, get_data } = mobileConfigurationReducer;
  return { loading, data, get_data };
};

const mapDispatchToProps = {
  AddMobileConfiguration,
  GetMobileConfiguration,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MobileConfiguration);
